import { collection, getDocs, query, where } from 'firebase/firestore';
import { FirestoreCollectionsPaths } from '../firebase/firebase.conts';
import { firestore } from '../firebase/firebase.utils';

const worksRef = collection(firestore, FirestoreCollectionsPaths.works);

export const fetchWorksFromFirebase = async () => {
  try {
    const querySnapshot = await getDocs(worksRef);

    return {
      data: querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
    };
  } catch (error) {
    return { error };
  }
};

export const fetchFeturedWorksFromFirebase = async () => {
  try {
    const q = query(worksRef, where('featured', '==', true));
    const querySnapshot = await getDocs(q);

    return {
      data: querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
    };
  } catch (error) {
    return { error };
  }
};
